/*
 * @Author: 张韶杰
 * @Date: 2024-10-31 11:14:34
 * @LastEditors: 张韶杰
 * @LastEditTime: 2024-11-01 12:02:19
 * @FilePath: \ysz_web_international-h5\src\store\getters.js
 * @Description: 
 * 
 */

const getters = {
  token: state => state.user.token,
  temporaryUserInfo: state =>state.user.temporaryUserInfo,
  isLogin: state => state.user.isLogin,
  fogotInfo: state => state.user.fogotInfo,
  anchorName: state => state.base.anchorName,
  userInfo: state => state.user.userInfo,
  activeNavName:state => state.base.activeNavName
}

export default getters
